import Vue from 'vue';
import * as types from './types';
// eslint-disable-next-line import/no-cycle
import axios from '../../lib/axios';
import storage from 'store';
import { errCodeMap } from '../../lib/errors';
import dayjs from 'dayjs';
import service from '@/lib/request';
import api from '@/apis/summary';
import commonApi from '@/apis/common';

const downloadFile = (url) => {
  const link = document.createElement('a');
  link.href = url;

  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

export default {
  namespaced: true,
  state: {
    newGuide: '',
    isErrorModal: false,
    chromeWarning: true,
    bindSaasPop: {
      isShow: false,
      // 1 企鹅小店 2 京东 3 拼多多
      type: 1,
      // 绑定信息赞存
      bindStateTemplate: {},
      isPddRebind: false,
    },
    withdrawPop: {
      isShow: false,
    },
    addGoodsPop: {
      isShow: false,
    },
    chooseMediaPop: {
      isShow: false,
      item: {},
    },
    withdrawGuidePop: {
      isShow: false,
    },
    changeBindPop: {
      isShow: false,
      bindInfo: {
        media: {},
        user: {},
      },
    },
    addAccountPop: {
      isShow: false,
    },
    inviteQrcodePop: {
      isShow: false,
    },
    bindMediaPop: {
      isShow: false,
    },
    bindPhonePop: {
      isShow: false,
    },
    // 微视子账号列表
    wsMediaUserList: [],
    wsCurrentMediaUser: {},
    // 导出状态： 1：空闲  2：正在导出  3：导出完成
    exportStatus: {
      summary: storage.get('exportSumStatus') || 1,
      order: storage.get('exportOrderStatus') || 1,
    },
    pddTokenPop: {
      isShow: false,
    },
    pddTokenExpire: -1,
  },
  mutations: {
    [types.SHOW_ERROR_MODAL](state) {
      state.isErrorModal = true;
    },
    [types.SET_CHROME_WARNING](state, data) {
      state.chromeWarning = data;
    },
    [types.HIDE_ERROR_MODAL](state) {
      state.isErrorModal = false;
    },
    [types.SHOW_BIND_SAAS_POP](state, payload = {}) {
      state.bindSaasPop.isShow = true;
      state.bindSaasPop.isPddRebind = payload.isPddRebind || false;
      // 4 为编辑京东ID  // 5 为编企鹅小店
      if ([4, 5].includes(Number(payload.type))) state.bindSaasPop.bindStateTemplate = payload;
      state.bindSaasPop.type = payload.type || state.bindSaasPop.type;
    },
    [types.HIDE_BIND_SAAS_POP](state) {
      state.bindSaasPop.isShow = false;
      this.dispatch('common/checkNewGuide');
    },
    [types.SHOW_ADD_GOODS_POP](state) {
      state.addGoodsPop.isShow = true;
    },
    [types.HIDE_ADD_GOODS_POP](state) {
      state.addGoodsPop.isShow = false;
    },
    [types.SHOW_CHOOSE_MEDIA_POP](state, payload = {}) {
      state.chooseMediaPop.isShow = true;
      state.chooseMediaPop.item = payload.item || {};
    },
    [types.HIDE_CHOOSE_MEDIA_POP](state) {
      state.chooseMediaPop.isShow = false;
    },
    [types.SHOW_WITHDRAW_POP](state) {
      state.withdrawPop.isShow = true;
    },
    [types.HIDE_WITHDRAW_POP](state) {
      state.withdrawPop.isShow = false;
    },
    [types.SET_WS_MEDIA_USER_LIST](state, payload = {}) {
      state.wsMediaUserList = payload.list || [];
    },
    [types.SET_WS_CURRENT_MEDIA_USER](state, payload = {}) {
      state.wsCurrentMediaUser = payload.current || {};
    },
    [types.SET_EXPORT_STATUS](state, { biz, status }) {
      // 开始导出
      Vue.prototype.$notification({
        icon: 'success',
        type: 'success',
        message: '导出成功，请勿关闭当前页面，数据文件将在导出成功后自动下载',
        closeable: false,
      });

      const bizMapFn = {
        1: () => {
          state.exportStatus.summary = status;
        },
        2: () => {
          state.exportStatus.order = status;
        },
        3: () => {
          state.exportStatus.summary = status;
        },
      };
      if (typeof bizMapFn[biz] === 'function') {
        bizMapFn[biz]();
      }
    },
    [types.SET_EXPORT_SUMMARY_STATUS](state, { status }) {
      state.exportStatus.summary = status;
    },
    [types.SET_EXPORT_ORDER_STATUS](state, { status }) {
      state.exportStatus.order = status;
    },
    [types.SHOW_WITHDRAW_GUIDE_POP](state) {
      state.withdrawGuidePop.isShow = true;
    },
    [types.HIDE_WITHDRAW_GUIDE_POP](state) {
      state.withdrawGuidePop.isShow = false;
    },
    [types.SHOW_CHANGE_BIND_POP](state, { bindInfo = {} }) {
      state.changeBindPop.isShow = true;
      state.changeBindPop.bindInfo = bindInfo;
    },
    [types.HIDE_CHANGE_BIND_POP](state) {
      state.changeBindPop.isShow = false;
    },
    [types.SHOW_ADD_ACCOUNT_POP](state) {
      state.addAccountPop.isShow = true;
    },
    [types.HIDE_ADD_ACCOUNT_POP](state) {
      state.addAccountPop.isShow = false;
    },
    [types.SHOW_INVITE_QRCODE_POP](state) {
      state.inviteQrcodePop.isShow = true;
    },
    [types.HIDE_INVITE_QRCODE_POP](state) {
      state.inviteQrcodePop.isShow = false;
    },
    [types.SHOW_BIND_MEDIA_POP](state) {
      state.bindMediaPop.isShow = true;
    },
    [types.HIDE_BIND_MEDIA_POP](state) {
      state.bindMediaPop.isShow = false;
    },
    [types.SHOW_BIND_PHONE_POP](state) {
      state.bindPhonePop.isShow = true;
    },
    [types.HIDE_BIND_PHONE_POP](state) {
      state.bindPhonePop.isShow = false;
    },
    [types.SHOW_PDD_TOKEN_EXPIRE_POP](state) {
      state.pddTokenPop.isShow = true;
    },
    [types.HIDE_PDD_TOKEN_EXPIRE_POP](state) {
      state.pddTokenPop.isShow = false;
    },
    [types.SET_PDD_TOKEN_EXPIRE](state, { expire }) {
      state.pddTokenExpire = expire;
    },
    checkNewGuide(state, data) {
      state.newGuide = data;
    },
  },
  actions: {
    // 获取媒体账号列表  1：微视  2：K歌
    async fetchMediaUserList({ commit }, { media = 1 }) {
      const data = {
        method: 'post',
        body: {
          media_type: media,
          page: 1,
          count: 1000,
        },
      };
      const res = await axios.post('v1/cp/medialist', data);

      if (res.code !== 0) {
        Vue.prototype.$tip.error(errCodeMap[res.code] || '媒体用户列表获取失败');
        return;
      }

      const mediaList = res.data.media_list;

      commit(types.SET_WS_MEDIA_USER_LIST, {
        list: mediaList,
      });

      commit(types.SET_WS_CURRENT_MEDIA_USER, {
        current: mediaList[0],
      });
    },
    // 查询导出状态  biz  1：数据概览列表  2：订单列表 3、结算账单下载
    async queryExportStatus(context, { biz = 1 }) {
      const data = {
        biz,
      };
      let apiName = 'exportOrderStatusQuery';
      if (biz === 3) {
        apiName = 'exportStatusQuery';
      }
      return api[apiName](data);
    },
    async createStatisticQueryTask(
      { dispatch, commit },
      { biz = 1, timeout = 5000 },
    ) {
      this.timer = setInterval(async () => {
        const res = await dispatch(
          'common/queryExportStatus',
          {
            biz,
          },
          {
            root: true,
          },
        );
        if (res.head.code === 0) {
          clearInterval(this.timer);
          this.timer = null;
          let { file_name: url } = res;
          if (res.result) {
            url = res.result.file_name;
          }
          downloadFile(url);
          // 还原可导出状态
          commit(types.SET_EXPORT_STATUS, {
            biz,
            status: 1,
          });
        }
      }, timeout);
    },

    async getPddExpireTime({ commit }) {
      const reqData = {
        code: 'xx',
        action: 2,
      };
      const res = await commonApi.getPddBindingStatus(reqData, false);

      if (res?.expires_in && Number(res?.expires_in) !== -1) {
        const expireTimestamp = res?.expires_in * 1000;
        const expireDate = dayjs(expireTimestamp).format('YYYY年MM月DD日');
        commit(types.SET_PDD_TOKEN_EXPIRE, { expire: expireDate });

        // 快过期的最后7天开始提醒续绑
        const tipsTimestamp = dayjs(Date.now()).add(7, 'day')
          .valueOf();
        if (expireTimestamp < tipsTimestamp) commit(types.SHOW_PDD_TOKEN_EXPIRE_POP);
      }
    },
    // 查看是否完成新手指引
    async checkNewGuide({ commit }) {
      service.post('v3/user/task', {}).then((res) => {
        if (res.code !== 0) {
          return;
        }

        commit('checkNewGuide', res);
        // this.newGuide = res;
      })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
        });
    },
  },
  // 在这写多模块状态的getter
  getters: {
    commonGetterExample(state, getters, rootState, rootGetters) {
      return rootGetters['userCenter/openSaasList'];
    },
  },
};
